<template>
    <v-radio-group :class="$style.radioGroup"
                   :value="value"
                   :disabled="disabled"
                   row
                   @change="onChange($event)">
      <v-radio v-for="option in options"
               color="#2C4F7A"
               :key="option.value"
               :label="option.label"
               :value="option.value">

        <template v-slot:label>
          <span :class="$style.labelHeader">
            {{ option.label }}
          </span>

          <span v-if="option.labelInfo"
                :class="$style.labelText">{{ option.labelInfo }}</span>
        </template>

      </v-radio>

    </v-radio-group>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    value: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e);
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.labelHeader {
  display: block;
  font-family: $title-font;
  color: $main-text-color;
  font-size: 1.6rem;
  line-height: 2.1rem;
  font-weight: 700;
  font-style: italic;
}

.labelText {
  display: block;
  margin-top: 4px;
  font-family: $main-font;
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-style: italic;
  color: $main-text-color;
}
</style>


<style lang="scss" >
@import "@/styles/variables.scss";

.v-input.v-input--selection-controls.v-input--radio-group {
  margin: 0;
  padding: 0;

  .v-input__control {
    flex-grow: 1;
  }

  &:not(.v-input--hide-details) {

    .v-input__control .v-input__slot {
      margin-bottom: 0;

      .v-input--radio-group__input {
        justify-content: space-between;
      }
    }

    .v-messages {
      display: none;
    }
  }

  .v-input--radio-group__input {

    .v-radio {
      align-items: flex-start;

      &:last-child {
        margin-right: 0;
      }

      .v-label {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }
}

</style>
